import { DEFAULT_BRANDING_FORM, PATCHABLE_BRANDING_KEYS } from "./branding-defaults";

const HEX_PATTERN = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

export const normalizeHexColor = (value, fallback = "#000000") => {
  if (!value || typeof value !== "string") return fallback;
  const trimmed = value.trim();
  if (HEX_PATTERN.test(trimmed)) {
    if (trimmed.length === 4) {
      const [, r, g, b] = trimmed;
      return `#${r}${r}${g}${g}${b}${b}`.toUpperCase();
    }
    return trimmed.toUpperCase();
  }
  return fallback;
};

export const isValidHexColor = (value) => typeof value === "string" && HEX_PATTERN.test(value.trim());

export const resolveBrandingImageUrl = (imageValue) => {
  if (!imageValue) return "";
  if (typeof imageValue === "string") return imageValue;
  return (
    imageValue.organizer_logo_big ||
    imageValue.organizer_card_big ||
    imageValue.big ||
    imageValue.organizer_card_medium ||
    imageValue.medium ||
    imageValue.organizer_logo_small ||
    imageValue.organizer_card_small ||
    imageValue.small ||
    imageValue.original ||
    ""
  );
};

export const BRANDING_IMAGE_KEYS = [
  "imageNextMatchCard",
  "imageFixtureCard",
  "imagePositionsCard",
  "imageGoalersCard",
  "imageSuspendedCard",
  "imageOutstandingCard",
  "imageFairplayCard",
  "imageCardsCard",
  "imageBarCard",
  "imageLoginBackground",
  "imageTeamCard",
  "ad1Image",
  "ad2Image",
  "ad3Image",
];

export const pickBrandingImages = (data = {}) =>
  BRANDING_IMAGE_KEYS.reduce((acc, key) => (data[key] !== undefined ? { ...acc, [key]: data[key] } : acc), {});

export const mapSettingsToForm = (data = {}) => {
  const next = { ...DEFAULT_BRANDING_FORM, name: data.name || "" };
  PATCHABLE_BRANDING_KEYS.forEach((key) => {
    if (data[key] !== undefined && data[key] !== null) {
      next[key] = data[key];
    }
  });
  Object.assign(next, pickBrandingImages(data));
  return next;
};

export const buildPatchPayload = (form) => {
  const payload = { name: form.name };
  PATCHABLE_BRANDING_KEYS.forEach((key) => {
    if (form[key] !== undefined) {
      payload[key] = form[key];
    }
  });
  return payload;
};

export const cardImageUrl = (form, card, localPreviews = {}) => {
  if (localPreviews[card.uploadField]) return localPreviews[card.uploadField];
  return resolveBrandingImageUrl(form[card.imageKey]);
};
